import React, {useEffect} from 'react'
import {ErrorElement, StyledIconButton} from './ErrorNotificationComponentStyle'
import {Alert, AlertTitle} from '@mui/material'
import CustomBox from '../../../components/common/CustomBox'
import Collapse from '@mui/material/Collapse'
import CloseIcon from '@mui/icons-material/Close'
import buttonTitles from '../../../appConfig/buttonTitles.config.json'
import PropTypes from 'prop-types'

const ErrorNotificationComponent = ({
  hidden,
  errorMessage,
  scrollToJurisdiction,
  scrollToHealth,
  scrollToDataAggregation,
  scrollToPointOfInterest
}) => {
  ErrorNotificationComponent.propTypes = {
    hidden: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    scrollToJurisdiction: PropTypes.func.isRequired,
    scrollToHealth: PropTypes.func.isRequired,
    scrollToDataAggregation: PropTypes.func.isRequired,
    scrollToPointOfInterest: PropTypes.func.isRequired
  }
  const [open, setOpen] = React.useState(true)
  const [ariaLabel, setAriaLabel] = React.useState(errorMessage)
  const handleOnClick = () => {
    if (errorMessage === 'Jurisdiction(s)') {
      scrollToJurisdiction.current.scrollIntoView()
    } else if (errorMessage === 'Data Aggregation') {
      scrollToDataAggregation.current.scrollIntoView()
    } else if (errorMessage === 'Points of Interest') {
      scrollToPointOfInterest.current.scrollIntoView()
    } else {
      scrollToHealth.current.scrollIntoView()
    }
  }

  useEffect(() => {
    errorMessage !== '' && setAriaLabel(errorMessage === 'Jurisdiction(s)' ? 'Jurisdictions' : errorMessage)
  }, [errorMessage])

  const projectDetailsLink = (
    <ErrorElement
      href='#'
      aria-label={`click-to-go-to-${ariaLabel}`}
      onClick={(event) => {
        event.preventDefault()
        handleOnClick()
      }}
    >
      {errorMessage}
    </ErrorElement>
  )

  const alertText = 'Please complete the following project details below'

  const alertTitle = <AlertTitle varient='h6'>{alertText}</AlertTitle>

  const updatedAriaLabel = `${alertText} ${ariaLabel}`
  return (
    !hidden && ( // we only need to render component if there is an error.Previously we were mounting even if there was no error.
      <CustomBox sx={{width: '100%'}}>
        <Collapse in={open}>
          <Alert
            variant='warning'
            tabIndex={0}
            severity='warning'
            action={
              <StyledIconButton
                title={buttonTitles.notificationTitle}
                aria-label='close'
                color='inherit'
                size='small'
                onClick={() => {
                  setOpen(false)
                }}
              >
                <CloseIcon fontSize='inherit' />
              </StyledIconButton>
            }
            aria-label={updatedAriaLabel}
            aria-live='off'
          >
            {alertTitle}
            {projectDetailsLink}
          </Alert>
        </Collapse>
      </CustomBox>
    )
  )
}

export default ErrorNotificationComponent
